import { ImageLoaderCSSStyleImpl } from '../../../toolkit/imageloader/imageloadercss';


export class BannerImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{

    getImgCSSStyle(): object 
    {
        return {
           width: '100%',
           // objectFit: 'contain', 
            // cursor: "pointer",
            // width: "100%",
            // height: "300px",
            // maxWidth: "none",
            maxHeight: "300px",
            objectFit: "cover",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerimageloadercss.ts